import { ApiMethodIcon } from '@/components/api-method-icon/ApiMethodIcon';
import { ApiMethodIconSize } from '@/components/api-method-icon/type/ApiMethodIconSize';
import { ApiType } from '@/shared/constant/ApiType';
import { ModelType } from '@tarslib/types/lib/common';
import { RequestMethodType } from '@tarslib/types/lib/httpApi';
import { FoxIconRightMd } from 'aui-biz-icons';
import clsx from 'clsx';
import { memo } from 'react';
import type { CallbackItem as ICallBackItem } from '../../../../shared/constant/ResourceData';

type CallbackListItemProps = {
  className?: string;
  selected?: boolean;
  onClick?: () => void;
  apiDetail?: ICallBackItem;
};

export const CallbackListItem = memo(function CallbackListItemComponent({
  className,
  selected = false,
  onClick,
  apiDetail,
}: CallbackListItemProps) {
  return (
    <button
      className={clsx(
        'flex h-12 w-full items-center gap-1 px-4 text-left',
        className,
        selected && 'bg-btn-text-hover',
      )}
      onClick={() => onClick?.()}
    >
      <ApiMethodIcon
        value={{
          type: ModelType.HttpApi,
          method: apiDetail?.method || RequestMethodType.GET,
          apiType: ApiType.Callback,
        }}
        size={ApiMethodIconSize.Large}
        apiLabelSize={ApiMethodIconSize.Default}
        disabledBackground
      />
      <span className="flex-1">{apiDetail?.path}</span>
      <FoxIconRightMd className="text-disabled" />
    </button>
  );
});
